module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 function isActive(name){
	return obj.order_by === name ? 'is-active' : '';
} 
__p+='\n\n<div class="trade-player-pool-table-head-container">\n	<div class="trade-player-pool-table-head table-head">\n		<div class="column column-1 js-order-by pointer player-column '+
((__t=( isActive('name') ))==null?'':_.escape(__t))+
'" data-order-by="name">PLAYER</div>\n		<div class="column column-2 js-order-by pointer major-stat-column '+
((__t=( is_mobile && mobile_column === 'stats.avg_points' ? '' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( isActive('stats.points_last_round') ))==null?'':_.escape(__t))+
'" data-order-by="stats.points_last_round">PTS</div>\n		';
 if(selected_match.status !== 'playing'){ 
__p+='\n			<div class="column column-3 js-order-by pointer major-stat-column '+
((__t=( is_mobile && mobile_column === 'stats.points_last_round' ? '' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points">AVG</div>\n		';
 } 
__p+='\n		';
 _.each(headings, function(item, index) { 
__p+='\n\n		<div class="column column-'+
((__t=( index + 4 ))==null?'':_.escape(__t))+
' tooltip-team js-order-by pointer match-stat-column '+
((__t=( item.key === 'TOG' ? '' : '' ))==null?'':_.escape(__t))+
'  '+
((__t=( isActive('match_stats.' + item.key) ))==null?'':_.escape(__t))+
'"\n		     title="'+
((__t=( item.tooltip ))==null?'':_.escape(__t))+
'"\n		     data-order-by="match_stats.'+
((__t=( item.key ))==null?'':_.escape(__t))+
'">\n			'+
((__t=( item.heading ))==null?'':_.escape(__t))+
'\n		</div>\n\n		';
 }) 
__p+='\n	</div>\n</div>';
}
return __p;
};
